<template>
  <div>
    <div class="row">
      <div class="col-md-12 text-right">
        <button v-if="devEmails.includes(user.email)" type="button" @click="syncRacks()" :disabled="loading" class="btn btn-primary">Sync Racks</button>
<!--        <button type="button" @click="openRacksModal('rack')" class="btn btn-primary">Add new rack</button>-->
      </div>

    </div>
    <div v-if="loading" class="loader"></div>
    <div v-else class="row" >
      <div v-for="(row1, index1) in filteredRacks" :key="index1" class="col-md-3">
        <div class="card" style="height: 277px">
          <div style="display: flex; align-items: center; padding: 0;" :style="`background: ${row1.color}`">
            <h6 class="col-md-9">{{row1.rackName}} ({{ row1.device_count }} Nodes)</h6>
            <span class="col-md-3 text-right">
              <a data-toggle="tooltip" data-placement="top" title="View Netbox" :href="`https://nb.bigscoots.fullctl.io/api/dcim/racks/${row1.rackId}`" target="_blank"><i class="fa fa-external-link"></i></a>
            </span>
          </div>
          <perfect-scrollbar class="scroll-area">
            <ul class="list-group mb-10">
              <li @click="viewNodeInfo(row2)"  v-for="(row2,index2) in row1.nodes" :key="index2" class="list-group-item make-cursor-pointer">
                {{row2.name}}
              </li>
            </ul>
          </perfect-scrollbar>
        </div>
      </div>
      <div v-if="unassignedNodes && unassignedNodes.length > 0" class="col-md-3">
        <div class="card" style="height: 277px">
          <div style="display: flex; align-items: center; padding: 0; background: indianred">
            <h6 class=" col-md-10">Unassigned Racks</h6>
          </div>
          <perfect-scrollbar class="scroll-area">
            <ul class="list-group">
              <li v-for="(row,index) in unassignedNodes" :key="index" class="list-group-item make-cursor-pointer">
                {{ row.name }}
              </li>
            </ul>
          </perfect-scrollbar>
        </div>
      </div>
    </div>
    <nodeInfoModal ref="nodeInfoModal"></nodeInfoModal>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import nodeInfoModal from "@/components/Admin/Dashboard/nodeInfoModal.vue";

export default {
  name: "Racks",
  components: {
    nodeInfoModal,
    PerfectScrollbar
  },
  data() {
    return {
      devEmails: ['sara@bigscoots.com'],
      allRacks: [],
      loading: false,
      allNodes: []
    }
  },

  computed: {
    filteredRacks() {
      return this.allRacks.filter(el => el.rackName && !el.unassigned).sort((a, b) => {
        if (a.rackName < b.rackName) return -1;
        if (a.rackName > b.rackName) return 1;
        return 0;
      });
    },
    unassignedNodes() {
      return this.allNodes.filter(el => !el.rack)
    }
  },
  async mounted(){
    this.loading = true
    await this.getAllRacks();
    this.loading = false;
  },
  methods: {
    viewNodeInfo(node) {
      console.log('helo')
      this.$refs.nodeInfoModal.load(node)
    },
    async getRandomLightColor() {
      console.log('random', )
      const min = 200; // Minimum value for each RGB component to ensure the color is light
      const max = 255; // Maximum value for each RGB component

      const r = Math.floor(Math.random() * (max - min + 1)) + min;
      const g = Math.floor(Math.random() * (max - min + 1)) + min;
      const b = Math.floor(Math.random() * (max - min + 1)) + min;
      console.log('`rgb(${r}, ${g}, ${b})`',`rgb(${r}, ${g}, ${b})`)
      return `rgb(${r}, ${g}, ${b})`;
    },
    async syncRacks() {
      try {
        this.loading = true;
        const response = await this.$http.post('/solus-vm/fetch-racks-from-netbox', {
          grant_type: 'token'
        })
        console.log('response from api', response.data)
      } catch (e) {
        console.log('error while sync rack', e.toString())
      } finally {
        this.loading = false
      }
    },
    openNodesModal(row){
      this.$parent.$refs.nodes.load(row)
    },
    openRacksModal(val){
      this.$parent.$refs.racks.load(val)
    },
    async getAllNodes(){
      this.allNodes=[];
      this.loading=true
      const nodesResp= await db.collection('netboxNodes').get();
      nodesResp.forEach(el => {
        this.allNodes.push({id: el.id, ...el.data()});
      })
      this.loading=false;
    },
    async getAllRacks(){
      try {
        this.allRacks=[]
        this.loading=true
        await this.getAllNodes();
        console.log(this.allNodes)
        const rackResp= await db.collection('racks').get();
        rackResp.forEach(async el => {
          let nodes=this.allNodes.filter(el1 => {
            console.log('el',el.data().rackId)
            return el1.rack ? el1.rack.id === el.data().rackId : false
          })
          console.log('nodes', nodes)
          if(nodes.length){
            this.allRacks.push({id: el.id, ...el.data(), nodes, unassigned: false, color: await this.getRandomLightColor()});
          }
          else{
            this.allRacks.push({id: el.id, ...el.data(), unassigned: true,  color: await this.getRandomLightColor()});
          }
        })
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
        console.log(this.allRacks)
      }catch (e) {
        console.log('error happened', e.toString())
      } finally {
        this.loading=false;
      }
    },
  }
}
</script>
<style scoped>
h6{
  margin-top: 9px;
}
.list-group-item:focus, .list-group-item:hover{
  z-index: 0!important;
}
</style>

